export default "__VITE_ASSET__421d7535__"